import type {
  ActivityReservation,
  BookerInfo,
} from "@b2bportal/rbc-activities-api";

export interface BookingDetailsSectionState {
  confirmationCode: string;
  bookerInfo: BookerInfo | null;
  bookerPhone: string;
  bookerEmail: string;
  supplierName: string;
  supplierPhone: string;
  supplierEmail: string;
  hasTravellerContact: boolean;
  hasTourOperator: boolean;
}

export function useBookingDetailsSection(
  reservation: ActivityReservation
): BookingDetailsSectionState {
  const bookingDetails = reservation.bookingDetails;
  const supplierInfo = reservation.activityDetails?.supplierInfo;

  const confirmationCode = reservation.customerReservationId;
  const bookerInfo = bookingDetails?.bookerInfo ?? null;
  const bookerPhone = bookingDetails?.bookingCommunicationInfo?.phone;
  const bookerEmail = bookingDetails?.bookingCommunicationInfo?.email;
  const supplierName = supplierInfo?.name;
  const supplierPhone = supplierInfo?.phone;
  const supplierEmail = supplierInfo?.email;
  const hasTravellerContact = Boolean(bookerPhone || bookerEmail);
  const hasTourOperator = Boolean(
    supplierName || supplierPhone || supplierEmail
  );

  return {
    confirmationCode,
    bookerInfo,
    bookerPhone,
    bookerEmail,
    supplierName,
    supplierPhone,
    supplierEmail,
    hasTravellerContact,
    hasTourOperator,
  };
}
